import { IntlShape, WrappedComponentProps } from '@futrli/localisation';
import { format } from 'date-fns';
import { forceLocalDate } from '../utils/dates';

import { ASSUMPTION_DATE_FORMAT } from './constants';

export const formatDate = (date: Date) => format(date, ASSUMPTION_DATE_FORMAT);

export const formatDateWithoutDay = (date: Date) => format(date, 'yyyy-MM');

export const formatlocalDate = (date: string, intl: WrappedComponentProps['intl']): string =>
  intl.formatDate(forceLocalDate(date), { month: 'long', year: 'numeric', day: '2-digit' });

export function stringPenceToAmount(value: string) {
  return penceToAmount(Number(value)).toString();
}

export function penceToAmount(value: number) {
  return value / 100;
}

export function stringAmountToPence(value: string) {
  return amountToPence(Number(value)).toString();
}

export function amountToPence(value: number) {
  return Math.floor(value * 100);
}

export const formatTAXName = (currency: string | undefined, intl: IntlShape): string =>
  currency && ['INR', 'NZD', 'USD', 'CAD', 'AUD'].includes(currency)
    ? intl.formatMessage({ id: 'common.gst', defaultMessage: 'GST' })
    : intl.formatMessage({ id: 'common.vat', defaultMessage: 'VAT' });
